
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/highlighted-scatter-mark",
      function () {
        return require("private-next-pages/x/api/charts/highlighted-scatter-mark.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/highlighted-scatter-mark"])
      });
    }
  